import styled from 'styled-components'
import Box from 'src/components/layout/Box'

export const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    background: #000000;
`
export const HeaderNavigation = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`
export const Content = styled(Box)`
    display: flex;
    flex-direction: column;
    background: #0e1920;
`

export const FooterNavigation = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: #0e1920;
`
export const OverContainerLoading = styled(Box)`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const PLoadingC = styled(Box)`
    width: 110.25px;
    height: 122.25px;
`

export const WhatsAppButton = styled.a`
    background: #23d366;
    position: fixed;
    bottom: 20px;
    right: 94px;
    width: 60px;
    height: 60px;
    border-radius: 30px;
    z-index: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

export const WhatsAppIcon = styled.img`
    height: 32px;
    width: 32px;
`
